import React, { useState } from 'react';
import { useShoppingList } from '../context/ShoppingListContext';
import './ShoppingListPage.css';

export default function ShoppingListPage() {
  const { items, toggleItem, removeItem, addManual, clearChecked, clearAll, uncheckedCount } = useShoppingList();
  const [inputVal, setInputVal] = useState('');
  const [copied, setCopied] = useState(false);
  const [blocked, setBlocked] = useState(false);

  const unchecked = items.filter(i => !i.checked);
  const checked   = items.filter(i => i.checked);

  const shareText = unchecked.length > 0
    ? `Einkaufsliste (Strixly):\n${unchecked.map(i => `• ${[i.amount, i.name].filter(Boolean).join(' ')}`).join('\n')}`
    : '';

  const hasNativeShare = typeof navigator !== 'undefined' && !!navigator.share;

  function handleAdd(e) {
    e.preventDefault();
    if (!inputVal.trim()) return;
    const ok = addManual(inputVal.trim());
    if (ok) {
      setInputVal('');
      setBlocked(false);
    } else {
      setBlocked(true);
      setTimeout(() => setBlocked(false), 3000);
    }
  }

  function handleWhatsApp() {
    window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`, '_blank');
  }

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(shareText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  }

  return (
    <div className="sl-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">
            Meine <em>Einkaufsliste</em>
          </h1>
          <p className="page-sub">
            {uncheckedCount > 0
              ? `${uncheckedCount} Artikel offen`
              : 'Alle Artikel erledigt'}
          </p>
        </div>

        {items.length > 0 && (
          <div className="sl-header-actions">
            <button className="btn btn-ghost btn-sm" style={{ color: 'var(--red)' }} onClick={clearAll}>
              🗑️ Alle löschen
            </button>
          </div>
        )}

        {unchecked.length > 0 && (
          <div className="sl-header-actions">
            {hasNativeShare && (
              <button className="btn btn-ghost btn-sm" onClick={() => navigator.share({ text: shareText }).catch(() => {})}>
                📤 Teilen
              </button>
            )}
            <button className="btn btn-ghost btn-sm sl-wa-btn" onClick={handleWhatsApp}>
              💬 WhatsApp
            </button>
            <button className="btn btn-ghost btn-sm" onClick={handleCopy}>
              {copied ? '✓ Kopiert' : '📋 Kopieren'}
            </button>
          </div>
        )}
      </div>

      {/* Eingabe */}
      <form onSubmit={handleAdd} className="sl-add-form">
        <input
          type="text"
          placeholder="Zutat manuell hinzufügen…"
          value={inputVal}
          onChange={e => setInputVal(e.target.value)}
          className="sl-add-input"
        />
        <button type="submit" className="btn btn-primary">Hinzufügen</button>
      </form>
      {blocked && (
        <div style={{ color: 'var(--red)', fontSize: '0.85rem', marginBottom: 8 }}>
          Dieser Inhalt ist nicht erlaubt.
        </div>
      )}

      {items.length === 0 ? (
        <div className="sl-empty">
          <p>Deine Einkaufsliste ist leer.</p>
          <p className="sl-empty-hint">Füge Zutaten direkt aus einem Rezept hinzu oder trage sie oben manuell ein.</p>
        </div>
      ) : (
        <div className="sl-body">
          {/* Offene Artikel */}
          {unchecked.length > 0 && (
            <section className="sl-section">
              <div className="sec-header">
                <span className="sec-title">Offen</span>
                <span className="sec-title" style={{ color: 'var(--green)' }}>{unchecked.length}</span>
              </div>
              <ul className="sl-list">
                {unchecked.map(item => (
                  <li key={item.id} className="sl-item">
                    <button className="sl-check" onClick={() => toggleItem(item.id)} aria-label="Erledigt">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                        <rect x="3" y="3" width="18" height="18" rx="4"/>
                      </svg>
                    </button>
                    <span className="sl-item-text">
                      {item.amount && <span className="sl-amount">{item.amount}</span>}
                      {item.name}
                    </span>
                    <button className="sl-remove" onClick={() => removeItem(item.id)} aria-label="Entfernen">✕</button>
                  </li>
                ))}
              </ul>
            </section>
          )}

          {/* Erledigte Artikel */}
          {checked.length > 0 && (
            <section className="sl-section sl-section--checked">
              <div className="sec-header">
                <span className="sec-title">Erledigt</span>
                <button className="sec-link" onClick={clearChecked}>Alle löschen</button>
              </div>
              <ul className="sl-list">
                {checked.map(item => (
                  <li key={item.id} className="sl-item sl-item--checked">
                    <button className="sl-check sl-check--done" onClick={() => toggleItem(item.id)} aria-label="Wiederherstellen">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="4" fill="currentColor" stroke="currentColor"/>
                        <polyline points="7 12 10 15 17 9" stroke="#fff" strokeWidth="2.5"/>
                      </svg>
                    </button>
                    <span className="sl-item-text sl-item-text--done">{item.name}</span>
                    <button className="sl-remove" onClick={() => removeItem(item.id)} aria-label="Entfernen">✕</button>
                  </li>
                ))}
              </ul>
            </section>
          )}
        </div>
      )}
    </div>
  );
}
